<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">加拿大萨省企业家移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>

        萨斯喀彻温省(简称萨省，Saskatchewan)被誉为加拿大的“产粮之篮”，萨省丰富的资源和创新的技术使其拥有北美最具竞争力的商业环境。加拿大萨省企业家移民项目已开放10余年的历史，因投资额较低、要求相对简单而受到众多申请人的青睐。

      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1、家庭净资产达到50万加币以上</p>
            <p>2、符合萨省EOI评分标准</p>
            <p>3、主申请人有至少3年经商管理经验</p>
            <p>4、两种投资方式：一为在萨省至少投资30万加币（里贾纳和萨斯卡通市）且至少为加拿大公民或者永久居民创造2个全职就业机会；二为至少投资20万加币（萨省其余城市）</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、资产要求低——家庭净资产最低要求50万加币</p>
            <p>2、投资成本少——投资资金最低仅需20万加币</p>
            <p>3、申请门槛低——无年龄、语言、学历、股东身份的硬性要求</p>
            <p>4、项目周期短——12个月获得工签，全家登陆加拿大，享有加拿大教育、健康福利</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/6.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、到萨省进行商务考察</p>
            <p>2、申请EOI</p>
            <p>3、面试</p>
            <p>4、申请工签</p>
            <p>5、登陆萨省做生意6个月</p>
            <p>6、获省提名批准信</p>
            <p>7、联邦审批</p>
            <p>8、获得枫叶卡</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'CaSa'
  }
</script>

<style scoped>

</style>
